var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('tng-header'),(_vm.$store.getters.isLoggedIn && _vm.$store.state.auth.user.expired === true)?_c('ExpiredTrial'):_vm._e(),_c('router-view'),_c('tng-footer'),(_vm.isSessionPopupVisible)?_c('session-popup'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }